import React, {useEffect, useState} from "react";
import Header from "../../components/navigation/Header";
import {useOutletContext, useParams} from "react-router-dom";
import {getModuleContentPreview} from "../../services/CourseRepository";
import {useError} from "../../hooks/useError";
import {FaLock} from "react-icons/fa";
import {TopBarNavigationCourse} from "../../components/navigation/TopBarNavigationCourse";
import {ChapterNavigationBar} from "../../components/navigation/ChapterNavigationBar";
import {CoursePage} from "./CoursePage";
import {setProductName} from "../../services/AxiosConfig";

export function CoursePreview() {

    const params = useParams();
    const [preview, setPreview] = useState(null);
    const [toggleSidebar, setToggleSidebar] = useState(true);
    const {setErrorMessage} = useError();

    useEffect(() => {
        getModuleContentPreview(params.courseName, params.moduleName, params.chapterName, setErrorMessage).then(result => {
            setPreview(result);
        }).catch(err => {
            console.log(err)
        });

    }, [params.courseName, params.moduleName, params.chapterName]);

    if(preview != null) {
        return (
            <div>
                <Header/>
                <div>

                    <div className={"bg-neutral-3 "}>

                        <div className={"row"}>
                            <div
                                className={"col-3 p-0 bg-white border-end sticky-sidebar  " + (!toggleSidebar ? "d-none" : "")}>
                                <ChapterNavigationBar courseId={params.courseName} initSelectedModule={preview.module}
                                                      preview={true}/>
                            </div>

                            <div className={"col bg-white"}>
                                {
                                    !preview.module.chapter.public ?

                                        <div
                                            className={"container d-flex text-center align-items-center h-100 justify-content-center"}>
                                            <div
                                                className={"d-flex flex-column text-center align-items-center h-100 justify-content-center text-muted"}
                                                style={{minHeight: "80vh"}}>
                                                <h1>{preview.module.chapter.title}</h1>
                                                <FaLock size={64}/>
                                                <h4 className={"mt-2"}> Kjøp produktet for å få tilgang </h4>
                                            </div>
                                        </div>
                                        :
                                        <CoursePage chapter={preview.module.chapter}/>
                                }
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}